import { Box, Typography } from "@mui/material";
import DownloadApp from "../components/DownloadApp";


function ReadyStart({
  phrase = "Ready to get started? Download SplitEV now",
  subtitle,
  CTAText = "",
}) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        py: { md: '18rem', xs: '5rem' },
        background: 'linear-gradient(264.22deg, #181A18 -124.15%, #0C0D0C 52.54%, #181A18 200.05%)',
        position: "relative",
        overflow: "hidden",
        height: { md: '54.4rem', xs: 'auto' },
      }}
    >
      <Box
        sx={{
          position: "absolute",
          width: "100%",
          height: "100%",
          zIndex: 0,
          opacity: 1,
          backgroundImage: `url(${require('../assets/images/footer_narrow_green_road.png')})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
        }}
      ></Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          zIndex: 5,
        }}
      >
        <Typography
          sx={{
            color: "white",
            fontFamily: "mulish",
            fontSize: { xs: "3.5rem", md: "4.8rem" },
            fontWeight: 700,
            textAlign: "center",
            maxWidth: "27ch",
            lineHeight: '1.2',
            my: '2rem',
          }}
        >
          {phrase}
        </Typography>

        {subtitle && <Typography
          sx={{
            fontFamily: "mulish",
            textAlign: "center",
            maxWidth: "70ch",
            lineHeight: '1.2',
            my: '1rem',
            fontSize: "1.5rem",
            fontWeight: 400,
            color: "paleWhite"
          }}
        >
          {subtitle}
        </Typography>}

        <DownloadApp></DownloadApp>
      </Box >
    </Box >
  );
}

export default ReadyStart;
